import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function WelcomeScreen() {
  const navigate = useNavigate();

  return (
    <div style={{ textAlign: 'center', padding: '4rem', fontFamily: 'Arial' }}>
      <h1>Welcome to Formalook</h1>
      <p>Empowering Better Decisions Before Surgery</p>
      <p>
        <span role="img" aria-label="under construction">🚧</span> We're building something amazing. Stay tuned.
      </p>
      <button
        onClick={() => navigate('/upload')}
        style={{
          marginTop: '2rem',
          padding: '1rem 2rem',
          fontSize: '1rem',
          backgroundColor: '#000',
          color: '#fff',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
        }}
      >
        Try Simulation →
      </button>
    </div>
  );
}
